import React from 'react'
import { useHistory } from 'react-router'
import { FaArrowLeft, FaSignOutAlt } from 'react-icons/fa'
import { MdAlbum, MdOutlineEvent, MdOutlinePlayCircleOutline } from 'react-icons/md'
import { Header } from 'layouts/basic'
import Button from 'components/Button'

import Menu from 'components/Menu'
import useAuthStore from 'store/auth'
import Avatar from 'components/Avatar'


export function AccountMainMenu(props) {
  const history = useHistory()
  const [active, setActive] = React.useState()

  const path = history.location.pathname.split('/')[2] ? history.location.pathname.split('/')[2] : ''
  React.useEffect(() => {
    setActive(path)
  }, [path])

  const onClick = value => {
    history.push('/account' + value)
  }

  return (
    <Menu position='top' containerClassName='bg-white sticky top-0'>
      <Menu.Item
        linkClassName='py-2'
        title='my compositions'
        icon={MdOutlinePlayCircleOutline}
        onClick={() => onClick('/')}
        active={active === ''}
      >
        <span className='hidden sm:block'>my compositions</span>
      </Menu.Item>
      <Menu.Item
        linkClassName='py-2'
        title='my albums'
        onClick={() => onClick('/albums')}
        active={active === 'albums'}
        icon={MdAlbum}
      >
        <span className='hidden sm:block'>my albums</span>
      </Menu.Item>
      <Menu.Item
        linkClassName='py-2'
        title='my events'
        onClick={() => onClick('/events')}
        icon={MdOutlineEvent}
        active={active === 'events'}
      >
        <span className='hidden sm:block'>my events</span>
      </Menu.Item>
    </Menu>
  )
}


export function AccounHeader(props) {
  const { data: currentUser, isLogged, logout } = useAuthStore()
  const history = useHistory()

  React.useEffect(() => {
    if ( ! isLogged) {
      logout()
    }
  }, [isLogged]) // eslint-disable-line

  return (
    <>
      <Header className='mb-0 py-5 bg-white'>
        <div className='relative max-w-3xl w-full m-auto'>
          <div className='flex items-center w-full bg-white'>
            <Button
              className='py-10 px-5 lg:px-10'
              onClick={() => history.goBack()}
            >
              <FaArrowLeft />
            </Button>
            <div className='flex-grow'>
              <Avatar withDescription horizontal edit user={currentUser} />
            </div>
            <Button
              theme='danger'
              className='py-10 px-5 lg:px-10'
              onClick={() => logout()}
            >
              <FaSignOutAlt />
            </Button>
          </div>
        </div>
      </Header>
      <AccountMainMenu />
    </>
  )
}
